import React, { Component } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import lscache from "lscache";
//
import Posts from "./posts";
//
class SocialMediaWall extends Component {
  constructor(props) {
    super(props);
    this.state = { data: null };
  }

  reMount = id => {
    const localData = this.getLocalStorageWall(id);

    if (localData) {
      this.setState({ data: localData });
    } else {
      this.fetchWall(id);
    }
  };

  getKey = id => {
    return `socialmediawall_20180302082714_${id}`;
  };

  setLocalStorageWall = (id, value) => {
    lscache.set(this.getKey(id), value, 60);
  };

  getLocalStorageWall = id => {
    return lscache.get(this.getKey(id));
  };

  fetchWall = id => {
    const { app_id, app_secret, limit, offset } = this.props;

    axios
      .get(`https://www.socialmediawall.io/api/v1.1/${id}/posts/`, {
        params: {
          app_id,
          app_secret,
          limit,
          offset
        }
      })
      .then(response => {
        const { data } = response.data;
        if (data.posts && data.posts.length > 0) {
          this.setLocalStorageWall(id, data);
          this.setState({ data });
        }
      })
      .catch(error => {
        this.setState({ data: null });
        console.log(error);
      });
  };

  componentDidMount = () => {
    this.reMount(this.props.id);
  };

  componentWillReceiveProps = nextProps => {
    if (nextProps.id !== this.props.id) {
      this.reMount(nextProps.id);
    }
  };

  render() {
    const { data } = this.state;
    return <>{data && <Posts {...data} />}</>;
  }
}

SocialMediaWall.defaultProps = {
  app_id: "c1a55cf2a95f4499aa777f7877358924",
  app_secret: "7c72dceb3f0a4a4d9489acf6eb181631",
  limit: 30,
  offset: 0
};

SocialMediaWall.propTypes = {
  id: PropTypes.any.isRequired
};

export default SocialMediaWall;
